export default "__VITE_ASSET__D_se3hE$__"